/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import TicketFormAccordion from './TicketFormAccordion';
import { alert } from 'util/alert'
import locale from './locale';
import placeOrderCtrl from 'controllers/ticket/placeOrder';
import Input from './Input';
import validator from 'validator';
import Transition from 'components/UI/Transition';
import OrderOverview from '../PosterView/OrderOverview';
import ReactPhoneInput from 'components/Form/Fields/PhoneNumber';
import './Modal.scss'

const DEFAULT_REGION_CODE = 'ca';

const validateRules = {
  full_name: ['required'],
  email: ['required', 'email'],
  phoneParsed: ['required', 'phoneParsed'],
}

const PHONE_LOCALE = 'en-CA';

class ModalContent extends React.Component {
  constructor(props) {
    super(props);

    this.attendeeArray = [];
    this.validateFns = [];

    let {poster_info} = props.posterDetail;

    this.state = {
      submitting: false,
      recipientFormError: {},
      attendeeNumber: props.orderInfo ? props.orderInfo.order.attendee.length : 0,
      paymentType: 'weChatPay',
      orderInfo: {},
      poster_info,
      ticket: props.orderInfo ? props.orderInfo.order.ticket : [],
      attendee: props.orderInfo ? props.orderInfo.order.attendee : [],
      recipient: props.orderInfo ? props.orderInfo.order.recipient : {full_name: '', email: '', phoneParsed: {country_code: '1', national_number: '', region_code : DEFAULT_REGION_CODE}},
    }

    this.onAttendeeChange = this.onAttendeeChange.bind(this);
    this.onRecipientChange = this.onRecipientChange.bind(this);
    this.dealWithFailure = this.dealWithFailure.bind(this);
    this.submit = this.submit.bind(this);
    this.validate = this.validate.bind(this);

  }

  onAttendeeChange(index) {
    return (applications)=>{
      this.attendeeArray[index] = applications;

      let attendeeNumber = 0;
      this.attendeeArray.map((arrays)=>{
        attendeeNumber += arrays.length;
      });

      this.setState({
        attendeeNumber,
      });
    };
  }

  onRecipientChange(name) {
    return((e) => {
      if(name == 'phoneParsed'){
        this.setState({
          recipient: {
            ...this.state.recipient,
            [name]: e,
          }
        })
      } else {
        this.setState({
          recipient: {
            ...this.state.recipient,
            [name]: e.target.value
          }
        })
      }
    })
  }

  renderClassList() {
    const {
      ticket
    } = this.props.posterDetail;

    return ticket.map((item, key)=>{
      return (
        <TicketFormAccordion
          attendee={this.state.attendee}
          ticket={item}
          key={key}
          onChange={this.onAttendeeChange(key)}
          registerValidate={(validateFn)=>{
            this.validateFns.push(validateFn(this.validate));
          }}
        />
      );
    });
  }

  validate(formData, validateRules) {

    let canSubmit = true;
    let formError = {}

    _.each(validateRules, (rules, name)=>{
      let value = formData[name];
      let newError;

      rules.map((rule)=>{

        switch(rule) {
          case 'required':
            if (typeof value == 'undefined' || value == '') {
              canSubmit = false;
              newError = __('This field must not be empty.', locale);
            }
            break;
          case 'email':
            if (value && !validator.isEmail(value)) {
              canSubmit = false;
              newError = __('A valid email is required.', locale);
            }
            break;
        }

        if (newError) {
          formError[name] = newError;
        }

      });

    });

    return { canSubmit, formError };
  }

  submit() {
    const {proceed, schoolId} = this.props;
    const {ticket} = this.props.posterDetail;

    let canSubmitAttendee = true;

    // validate all the attendee forms
    this.validateFns.map((validateFn)=>{
      canSubmitAttendee = validateFn();
    });


    // validate contact info form
    const result = this.validate(this.state.recipient, validateRules);
    let canSubmitRecipient = result.canSubmit;

    if (!canSubmitAttendee || !canSubmitRecipient) {
      this.setState({
        recipientFormError: result.formError,
      });

      return;
    }

    // formatting
    let newAttendees = [];
    this.attendeeArray.map((attendees)=>{
      newAttendees = [...newAttendees, ...attendees];
    });
    this.state.attendee = newAttendees;

    let ticketNumbers = {};

    // calculating tickets
    this.state.attendee.map((attendee)=> {
      if (attendee.ticket_id) {
        if (typeof ticketNumbers[attendee.ticket_id] == 'undefined') {
          ticketNumbers[attendee.ticket_id] = 0;
        }
        ticketNumbers[attendee.ticket_id] ++;
      } else {
        throw new Error("attendee is missing ticket_id");
      }
    });

    let arr = []

    ticket.map((item)=>{
      const { id, price } = item;
      if (ticketNumbers[id]) {
        arr.push({ticket_id: id, price: parseFloat(price), amount: ticketNumbers[id]})
        this.setState({ticket: arr})
      }
    });

    // reformatting
    // if attendee's email or phone is empty, we use recipient's phone and email
    this.state.attendee.map((attendee)=>{
      attendee.phone = attendee.phoneParsed.national_number.length > 2 ? attendee.phoneParsed.country_code + attendee.phoneParsed.national_number : this.state.recipient.phoneParsed.country_code + this.state.recipient.phoneParsed.national_number
      attendee.email = attendee.email || this.state.recipient.email

      delete attendee.phoneParsed
    });

    this.setState({
      submitting: true,
    });

    let newRecipient = {...this.state.recipient, phone: this.state.recipient.phoneParsed.country_code + this.state.recipient.phoneParsed.national_number}
    delete newRecipient.phoneParsed

    // make atteendee, recipent, ticket into one object for API
    let order = {ticket: arr, recipient: newRecipient, attendee: this.state.attendee}

    placeOrderCtrl(schoolId, order)
    .then(({result, reason, order_number})=>{
      this.setState({
        submitting: false,
      });
      if (result == 'failure') {
        this.dealWithFailure(reason)
      }
      if (result == 'success') {
        proceed({ result, orderInfo: { result, order, price_type: ticket[0].price_type, ticketInfo: ticket }, order_number});
      }
    })
    .catch((err)=>{
      console.error(err);
    });
  }

  dealWithFailure(reason) {
    switch (reason) {
    case 'no slot left':
      alert.fail(__('No more space left.', locale), __('Registration Failed', locale));
      break;
    case 'no contact info':
      alert.fail(__('Contact info is missing.', locale), __('Registration Failed', locale));
      break;
    }
  }

  render() {
    const {
      submitting,
      recipientFormError,
      attendeeNumber,
      recipient,
    } = this.state;

    const {full_name, email, phoneParsed} = recipient


    return (
      <div className='Register-Class-Modal-Content'>
        <div className='class-list'>
          {this.renderClassList()}
        </div>
        <Transition type='expand'>
        { (attendeeNumber > 0 || this.props.orderInfo) &&
          <div>
            <div className='recipient-info'>
              <div className='recipient-info-content'>
                <h4>{__('Contact Info', locale)}</h4>
                <div className={classnames('col-sm-12 form-group', { hasError: recipientFormError['full_name'] })}>
                  <label>{__('Full Name', locale)}<span className='required'>*</span></label>
                  <input type='text' value={full_name} onChange={this.onRecipientChange('full_name')} />
                  <div className='error-msg'>{recipientFormError['full_name']}</div>
                </div>
                <div className={classnames('col-sm-12 form-group', { hasError: recipientFormError['email'] })}>
                  <label>{__('Email', locale)}<span className='required'>*</span></label>
                  <input type='text' value={email} onChange={this.onRecipientChange('email')} />
                  <div className='error-msg'>{recipientFormError['email']}</div>
                </div>
                <div className={classnames('col-sm-12 form-group', { hasError: recipientFormError['phone'] })}>
                  <label>{__('Phone', locale)}<span className='required'>*</span></label>
                  <ReactPhoneInput
                    inputStyle={{height: '40px'}}
                    className='form-control'
                    defaultCountry={'ca'}
                    value={phoneParsed}
                    onChange={this.onRecipientChange('phoneParsed')}
                    onlyCountries={['ca', 'us']}
                    disableAreaCodes={true}
                  />
                  <div className='error-msg'>{recipientFormError['phone']}</div>
                </div>

                <button className='btn btn-primary' disabled={submitting} onClick={this.submit}>
                  {!submitting && __('Next', locale)}
                  {submitting && __('Next', locale)}
                </button>
              </div>
            </div>
          </div>
          }
        </Transition>
      </div>
    )
  }

}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/shared/RegisterClassModal/ModalContent.js